export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6999.86e848d0.jpg";